import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export abstract class JsonParser {
  abstract parse(text: string): any;
}

@Injectable()
export class CustomJsonInterceptor implements HttpInterceptor {
  constructor(private jsonParser: JsonParser) { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler) {
    if (httpRequest.responseType === 'json') {
      // If the expected response type is JSON then handle it here.
      return this.handleJsonResponse(httpRequest, next);
    } else {
      return next.handle(httpRequest);
    }
  }

  private handleJsonResponse(httpRequest: HttpRequest<any>, next: HttpHandler) {
    // Override the responseType to disable the default JSON parsing.
    httpRequest = httpRequest.clone({ responseType: 'text' });
    // Handle the response using the custom parser.
    return next.handle(httpRequest).pipe(map(event => this.parseJsonResponse(event)));
  }

  private parseJsonResponse(event: HttpEvent<any>) {
    if (event instanceof HttpResponse && typeof event.body === 'string') {
      return event.clone({ body: this.jsonParser.parse(event.body) });
    } else {
      return event;
    }
  }
}

@Injectable()
export class CustomJsonParser implements JsonParser {
  parse(text: string): any {
    if (text)
      return JSON.parse(text, dateReviver);
    return null;
  }
}

const DATE_REGEX = /\d{4}-[01]\d-[0-3]\d(T[0-2]\d:[0-5]\d(?::[0-5]\d(?:\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)?)?)?)?/;
function dateReviver(_: string, value: any) {
  if (typeof value === 'string') {
    if (value.search(DATE_REGEX) >= 0) {
      return new Date(value);
    }
  }

  return value;
}
